import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BasePaths } from 'src/app/constants/routes';
import {
  DataProcessingAddendumTitle,
  DataProcessingAddendumTitleJsonKey,
  DataProcessingAddendumText,
  DataProcessingAddendumTextJsonKey,
} from 'src/app/constants/static-text';

@Component({
  selector: 'mwp-data-processing-addendum',
  templateUrl: './data-processing-addendum.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataProcessingAddendumComponent {
  public returnLink: string = BasePaths.Members;
  public dataProcessingAddendumTitle: string = DataProcessingAddendumTitle;
  public dataProcessingAddendumTitleJsonKey: string =
    DataProcessingAddendumTitleJsonKey;
  public dataProcessingAddendumText: string = DataProcessingAddendumText;
  public dataProcessingAddendumTextJsonKey: string =
    DataProcessingAddendumTextJsonKey;

  constructor() {}

  download() {
    window
      .open(
        'https://www.myworkplace.net/imagesclient/assets/MyWorkplaceDataProcessingAddendum.pdf',
        '_blank'
      )
      .focus();
  }
}
